module.exports = __webpack_public_path__ + "img/logo5.b6da8e89.jpg";